import { render } from "./Layout.vue?vue&type=template&id=74a30c33"
const script = {}
script.render = render

export default script